module.exports = __webpack_public_path__ + "static/illustration_landing_report-bead012a6bfeac88673fabc5115d8abc.svg";